/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { CSMECertificateListContainer } from './container';
import { useNavigate } from 'react-router-dom';

export const CSMECertificateListPage = ({
  navigation,
}: {
  navigation: any;
}) => {
  const navigate = useNavigate();

  return (
    <CSMECertificateListContainer
      onViewClick={(id: string) => {
        navigate(`/applications?credential=${id}`, {
          state: { from: 'renew' },
        });
        // navigate('/application-form', {
        //   state: {
        //     data: {
        //       status: 'APPLIED_FOR_RENEWAL',
        //       type: 'RENEW_CSME_CERTIFICATE',
        //       applicationNo:'RCSME-22434339'
        //     },
        //   },
        // });
      }}
    />
  );
};
